'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
const Func = require("../func");
const $ = require("jquery");
class Contact {
    constructor(
    // 空白チェック項目
    notNullKeys = ['contact_type', 'your_name', 'your_name_kana', 'email', 'email_re', 'body', 'accept']) {
        this.notNullKeys = notNullKeys;
        $('#trigContactSubmit').on('click', () => {
            $('.bulletContactErrorMessage').hide();
            const values = this.getValues();
            console.log(values);
            return this.validates(values);
        });
    }
    getValues() {
        return {
            contact_type: $('.paramContactValue[data-name="contact_type"]').val(),
            your_name: $('.paramContactValue[data-name="your_name"]').val(),
            your_name_kana: $('.paramContactValue[data-name="your_name_kana"]').val(),
            email: $('.paramContactValue[data-name="email"]').val(),
            email_re: $('.paramContactValue[data-name="email_re"]').val(),
            body: $('.paramContactValue[data-name="body"]').val(),
            accept: $('.paramContactValue[data-name="accept"]:checked').val(),
        };
    }
    validates(values) {
        let errorName = '';
        // 空白チェック
        this.notNullKeys.forEach(function (v) {
            if (Func.isNull(values[v])) {
                $('.bulletContactErrorMessage[data-name="' + v + '"]').show();
                if (!errorName) {
                    errorName = v;
                }
            }
        });
        // メールフォーマット
        if (!Func.isNull(values.email) && !Func.matchEmailFormat(values.email)) {
            $('.bulletContactErrorMessage[data-name="email_not_matched"]').show();
            if (!errorName) {
                errorName = 'email';
            }
        }
        // メール確認用チェック
        if (!Func.isNull(values.email_re) && (values.email !== values.email_re)) {
            $('.bulletContactErrorMessage[data-name="email_re_not_match"]').show();
            if (!errorName) {
                errorName = 'email';
            }
        }
        // エラー時処理
        if (errorName) {
            this.scrollToError(errorName);
            return false;
        }
    }
    // 指定の入力欄の位置までスクロール
    scrollToError(errorName) {
        const formPosition = $('.bulletContactError[data-name="' + errorName + '"]').offset().top;
        const headerHeight = $('.paramHeader').outerHeight() || 0;
        $('html, body').animate({
            scrollTop: formPosition - headerHeight
        }, 'slow');
    }
}
exports.Contact = Contact;
exports.default = Contact;
